import React, { useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers, faUserTag
} from '@fortawesome/free-solid-svg-icons';
import Header from '../../component/header/header';
import Sidebar from '../../component/sidebar/sidebar';
import UsersList from './components/UsersList';
import UserPermissionsPage from './components/UserPermissionsPage';
import RolesList from './components/RolesList';
import {
  useUsers,
  useRoles,
  useResourceTypes,
} from './hooks/useAuthorizationData';
import './Authorization.css';

const Authorization = (props) => {
  const [activeTab, setActiveTab] = useState('users');
  const [selectedUser, setSelectedUser] = useState(null);
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [selectedRoleFilter, setSelectedRoleFilter] = useState([]);

  const { data: users, isLoading: usersLoading, refetch: refetchUsers } = useUsers(selectedRoleFilter);
  const { data: roles, isLoading: rolesLoading, refetch: refetchRoles } = useRoles();
  const { data: resourceTypes } = useResourceTypes();

  const handleSelectUser = (user) => {
    setSelectedUser(user);
    setActiveTab('user-permissions');
  };

  const handleBackFromUser = () => {
    setSelectedUser(null);
    setActiveTab('users');
  };

  return (

        <div className="d-flex flex-row mainclass" style={{ height: "100vh", overflow: "auto" }}>
          <div style={{ flex: sidebarExpanded ? "0 0 21%" : "0 0 60px", position: "sticky", top: 0, zIndex: 999 }}>
            <Sidebar dataFromParent={props.location.pathname} onSidebarToggle={setSidebarExpanded} />
          </div>
    
          <div style={{ flex: "1", transition: "all 0.3s ease" }}>
            <div style={{ position: "sticky", top: 0, zIndex: 999 }}><Header /></div>
            <div className="content-wrapper">
              <div className="auth-page-header">
                <h1>Authorization & Permissions</h1>
                <p>Manage roles, capabilities, and access control for your ESG platform</p>
              </div>

              <Tab.Container
                activeKey={activeTab}
                onSelect={(k) => {
                  if (k !== 'user-permissions') setSelectedUser(null);
                  setActiveTab(k);
                }}
              >
                {activeTab !== 'user-permissions' && (
                  <Nav variant="tabs" className="auth-main-tabs mb-0">
                    <Nav.Item>
                      <Nav.Link eventKey="users">
                        <FontAwesomeIcon icon={faUsers} className="me-2" />
                        Users
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="roles">
                        <FontAwesomeIcon icon={faUserTag} className="me-2" />
                        Roles
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                )}

                <Tab.Content>
                  <Tab.Pane eventKey="users">
                    {activeTab === 'users' && (
                      <UsersList
                        users={users}
                        isLoading={usersLoading}
                        onSelectUser={handleSelectUser}
                        roles={roles}
                        onRefetch={refetchUsers}
                        selectedRoleFilter={selectedRoleFilter}
                        onRoleFilterChange={setSelectedRoleFilter}
                      />
                    )}
                  </Tab.Pane>

                  <Tab.Pane eventKey="user-permissions">
                    {activeTab === 'user-permissions' && selectedUser && (
                      <UserPermissionsPage
                        user={selectedUser}
                        resourceTypes={resourceTypes}
                        onBack={handleBackFromUser}
                      />
                    )}
                  </Tab.Pane>

                  <Tab.Pane eventKey="roles">
                    {activeTab === 'roles' && (
                      <RolesList
                        roles={roles}
                        isLoading={rolesLoading}
                        onRefetch={refetchRoles}
                      />
                    )}
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>

  );
};

export default Authorization;